var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"rounded-xxl",class:_vm.className},'v-btn',[_vm.defaultProps, _vm.$attrs],false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Button")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }